export const translations = {
  en: {
    // Header & Navigation
    siteTitle: "Podcast Archive",
    tagline: "2001-2014 Collection",
    home: "Home",
    browse: "Browse",
    queue: "Queue",
    settings: "Settings",
    update: {
      available: "A new version is available",
      reload: "Update",
    },
    myPlaylist: "Queue",
    searchAndFilter: "Search & Filter",

    // Hero Section
    hero: {
      type: "Podcast Archive",
      title: "On va s'gêner",
      episodes: "episodes",
      host: "Laurent Ruquier",
      shufflePlay: "Shuffle Play",
      filters: "Filters",
    },

    // Search & Filters
    searchTitleDescription: "Search Title/Description",
    searchPlaceholder: "Search episodes...",
    dateRange: "Date Range",
    fromDate: "From",
    toDate: "To",
    dateTo: "to",
    filterByParticipants: "Filter by Participants",
    participantPlaceholder: "Enter participant name...",
    addButton: "Add",
    removeParticipant: "Remove participant",
    searchButton: "Search",
    resetButton: "Reset",
    searching: "Searching",

    // Podcast List & Cards
    podcastArchive: "Podcast Archive",
    foundResults: "Found {count} podcast{plural}",
    loadingPodcasts: "Loading podcasts...",
    noPodcastsFound: "No podcasts found",
    tryAdjusting: "Try adjusting your search criteria or filters.",
    duration: "Duration",
    withLabel: "With",
    playButton: "Play",
    addToPlaylist: "Add to Queue",
    browsePodcasts: "Browse Podcasts",

    // Audio Player
    nowPlaying: "Now Playing",
    previousTrack: "Previous Track",
    nextTrack: "Next Track",
    skipBack: "Skip 15s Back",
    skipForward: "Skip 15s Forward",
    playPause: "Play/Pause",
    volume: "Volume",
    speed: "Speed",

    // Queue Manager
    queueTitle: "Queue",
    emptyQueueTitle: "Your queue is empty",
    emptyQueueMessage: "Add some podcasts to your queue to get started!",
    playlistTitle: "Queue",
    playlistCount: "({count} episodes)",
    exportPlaylist: "Export",
    sharePlaylist: "Share",
    clearPlaylist: "Clear All",
    emptyPlaylistTitle: "Your queue is empty",
    emptyPlaylistMessage: "Add some podcasts to your queue to get started!",
    totalEpisodes: "Total episodes: {count}",
    playEpisode: "Play episode",
    removeFromPlaylist: "Remove from queue",

    // Actions & Buttons
    play: "Play",
    pause: "Pause",
    stop: "Stop",
    add: "Add",
    remove: "Remove",
    clear: "Clear",
    export: "Export",
    share: "Share",
    search: "Search",
    reset: "Reset",
    close: "Close",
    minimize: "Minimize",
    expand: "Expand",

    // Messages & Notifications
    addedToPlaylist: "Added to queue",
    removedFromPlaylist: "Removed from queue",
    playlistCleared: "Queue cleared",
    playlistExported: "Queue exported",
    sharePlaylistTitle: "My Podcast Queue",
    sharePlaylistText: "Check out my podcast queue!",

    // Date & Time
    dateFormat: "MMM dd, yyyy",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",

    // Languages
    language: "Language",
    english: "English",
    french: "Français",

    // Errors
    errorLoading: "Error loading podcasts",
    errorPlaying: "Error playing audio",
    errorGeneric: "An error occurred",

    // Metadata
    tags: "Tags",
    participants: "Participants",
    description: "Description",
    title: "Title",
    date: "Date",

    // Comments
    commentsTitle: "Comments",
    pseudo: "Pseudo (optional)",
    name: "Name (optional)",
    yourName: "Your Name",
    yourComment: "Your Comment",
    postComment: "Post Comment",
    submittingComment: "Posting...",
    loadingComments: "Loading comments...",
    loadingMoreComments: "Loading more comments...",
    noMoreComments: "No more comments to load",
    noCommentsYet: "No comments yet",
    beFirstToComment: "Be the first to comment on this episode!",
    failedToFetchComments: "Failed to fetch comments",
    errorFetchingComments: "Error fetching comments",
    commentPostedSuccessfully: "Comment posted successfully!",
    fillAllFields: "Please fill in all fields",
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Information",
    commentSubmissionFailed: "Failed to submit comment",
    commentSubmissionError: "Error submitting comment. Please try again.",

    // Theme
    switchToLightMode: "Switch to light mode",
    switchToDarkMode: "Switch to dark mode",

    // Playlist/Queue
    playAll: "Play All",
    pauseButton: "Pause",

    rewind15s: "Rewind 15 seconds",
    forward15s: "Forward 15 seconds",
    cancel: "Cancel",

    // Icons
    userIcon: "👤",
    loadingSpinner: "Loading...",
    commentsCount: "{count}",
    commentAuthor: "Author",
    commentTimestamp: "Posted {time}",
    dragHandle: "Drag to reorder",
    removeFromPlaylistTooltip: "Remove from queue",
    playIcon: "▶",
    pauseIcon: "⏸",
    emptyIcon: "🎧",
    playlistIcon: "📋",
    commentsIcon: "💬",
    calendarIcon: "📅",
    clockIcon: "⏱️",
    tagsIcon: "🏷️",
    musicIcon: "🎵",
    searchIcon: "🔍",

    // Share Episode
    shareEpisode: "Share",
    shareEpisodeAtTime: "Share at current time",
    shareEpisodeTitle: "Listen to this episode",
    shareEpisodeText: "Check out this podcast episode!",

    speedOptions: { "0.5": "0.5x", "0.75": "0.75x", "1": "1x", "1.25": "1.25x", "1.5": "1.5x", "2": "2x" },

    // Tooltips
    nowPlayingAria: "Now playing audio",
    searchDialogTitle: "Search and Filter Podcasts",
    searchDialogSubtitle: "Find your favorite episodes",
    closeDialog: "Close search dialog",
    previousTrackTooltip: "Previous track",
    nextTrackTooltip: "Next track",
    rewindTooltip: "Rewind 15 seconds",
    forwardTooltip: "Forward 15 seconds",
    playTooltip: "Play",
    pauseTooltip: "Pause",
    volumeTooltip: "Volume control",
    speedTooltip: "Playback speed",
    progressBarTooltip: "Click to seek",
    expandPlayer: "Expand player",
    minimizePlayer: "Minimize player",
    closePlayer: "Close player",
    toggleMobileMenu: "Toggle mobile menu",
    selectPodcastToStart: "Select a podcast to start listening",
    chooseFromListOrPlaylist: "Choose from the list or add podcasts to your queue",

    // Summary Statistics
    stats: {
      title: "Archive Statistics",
      totalEpisodes: "Total Episodes",
      totalDuration: "Total Duration",
      dateRange: "Date Range",
      averageEpisode: "Average Episode",
      averageSize: "{mb} MB per episode",
      durationSublabel: "{hours} hours (approximately {days} days of content!)",
      lastUpdated: "Last updated: {date}",
    },

    // Install prompt
    install: {
      title: 'Install the app',
      androidBody: 'Add it to your home screen for quick, full-screen access.',
      iosBody: 'Tap the Share icon, then "Add to Home Screen".',
      cta: 'Install',
      dismiss: 'Dismiss',
    },

    // Offline downloads
    offline: {
      downloadForOffline: 'Download for offline',
      availableOffline: 'Available offline',
      downloading: 'Downloading…',
      queued: 'Queued',
      removeOffline: 'Remove download',
      cancelDownload: 'Cancel',
      downloadFailed: 'Download failed',
      downloads: 'Downloads',
      storageUsed: 'Storage used',
      removeAll: 'Remove all',
      noDownloads: 'No downloads yet',
    },

    // Episode detail page (/episode/:id) + "View details" entry points
    episode: {
      notFound: "Episode not found",
      backHome: "Back to home",
      viewDetails: "View details",
      play: "Play",
      pause: "Pause",
      share: "Share",
    },

    // Toasts (replace the old native-dialog share fallbacks)
    toast: {
      linkCopied: "Link copied",
      copyFailed: "Couldn't copy — {url}",
    },

    // Global download strip + downloads-manager Active block (Task 6)
    downloads: {
      remaining: "{count} remaining",
      failed: "{count} failed",
      active: "Downloading",
      cancel: "Cancel",
      retry: "Retry",
    },

    // Destructive-action confirmations (Task 7)
    confirm: {
      removeAllDownloads: {
        title: "Remove all downloads?",
        message: "This removes every downloaded episode from this device.",
      },
      clearQueue: {
        title: "Clear the queue?",
        message: "This removes every episode from your queue.",
      },
      confirm: "Confirm",
      cancel: "Cancel",
    },
  },

  fr: {
    // Header & Navigation
    siteTitle: "Archives Podcast",
    tagline: "Collection 2001-2014",
    home: "Accueil",
    browse: "Parcourir",
    queue: "File d'attente",
    settings: "Réglages",
    update: {
      available: "Une nouvelle version est disponible",
      reload: "Mettre à jour",
    },
    myPlaylist: "File d'attente",
    searchAndFilter: "Recherche et Filtres",

    // Hero Section
    hero: {
      type: "Archives Podcast",
      title: "On va s'gêner",
      episodes: "épisodes",
      host: "Laurent Ruquier",
      shufflePlay: "Lecture aléatoire",
      filters: "Filtres",
    },

    // Search & Filters
    searchTitleDescription: "Rechercher Titre/Description",
    searchPlaceholder: "Rechercher des épisodes...",
    dateRange: "Période",
    fromDate: "De",
    toDate: "À",
    dateTo: "à",
    filterByParticipants: "Filtrer par Participants",
    participantPlaceholder: "Entrez le nom du participant...",
    addButton: "Ajouter",
    removeParticipant: "Supprimer le participant",
    searchButton: "Rechercher",
    resetButton: "Réinitialiser",
    searching: "Recherche en cours",

    // Podcast List & Cards
    podcastArchive: "Archives Podcast",
    foundResults: "Trouvé {count} podcast{plural}",
    loadingPodcasts: "Chargement des podcasts...",
    noPodcastsFound: "Aucun podcast trouvé",
    tryAdjusting: "Essayez d'ajuster vos critères de recherche ou filtres.",
    duration: "Durée",
    withLabel: "Avec",
    playButton: "Écouter",
    addToPlaylist: "Ajouter à la file",
    browsePodcasts: "Parcourir les Podcasts",

    // Audio Player
    nowPlaying: "En Cours",
    previousTrack: "Piste Précédente",
    nextTrack: "Piste Suivante",
    skipBack: "Reculer 15s",
    skipForward: "Avancer 15s",
    playPause: "Lecture/Pause",
    volume: "Volume",
    speed: "Vitesse",

    // Queue Manager
    queueTitle: "File d'attente",
    emptyQueueTitle: "Votre file d'attente est vide",
    emptyQueueMessage: "Ajoutez des podcasts à votre file d'attente pour commencer !",
    playlistTitle: "File d'attente",
    playlistCount: "({count} épisodes)",
    exportPlaylist: "Exporter",
    sharePlaylist: "Partager",
    clearPlaylist: "Tout Effacer",
    emptyPlaylistTitle: "Votre file d'attente est vide",
    emptyPlaylistMessage: "Ajoutez des podcasts pour commencer !",
    totalEpisodes: "Total épisodes : {count}",
    playEpisode: "Écouter l'épisode",
    removeFromPlaylist: "Retirer de la file d'attente",

    // Actions & Buttons
    play: "Écouter",
    pause: "Pause",
    stop: "Arrêter",
    add: "Ajouter",
    remove: "Retirer",
    clear: "Effacer",
    export: "Exporter",
    share: "Partager",
    search: "Rechercher",
    reset: "Réinitialiser",
    close: "Fermer",
    minimize: "Réduire",
    expand: "Étendre",

    // Messages & Notifications
    addedToPlaylist: "Ajouté à la file d'attente",
    removedFromPlaylist: "Retiré de la file d'attente",
    playlistCleared: "File d'attente effacée",
    playlistExported: "File d'attente exportée",
    sharePlaylistTitle: "Ma File d'attente Podcast",
    sharePlaylistText: "Découvrez ma file d'attente podcast !",

    // Date & Time
    dateFormat: "dd MMM yyyy",
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",

    // Languages
    language: "Langue",
    english: "English",
    french: "Français",

    // Errors
    errorLoading: "Erreur lors du chargement des podcasts",
    errorPlaying: "Erreur lors de la lecture audio",
    errorGeneric: "Une erreur s'est produite",

    // Metadata
    tags: "Étiquettes",
    participants: "Participants",
    description: "Description",
    title: "Titre",
    date: "Date",

    // Comments
    commentsTitle: "Commentaires",
    pseudo: "Pseudo (optionnel)",
    name: "Nom (optionnel)",
    yourName: "Votre Nom",
    yourComment: "Votre Commentaire",
    postComment: "Publier",
    submittingComment: "Publication...",
    loadingComments: "Chargement des commentaires...",
    loadingMoreComments: "Chargement de plus de commentaires...",
    noMoreComments: "Aucun commentaire supplémentaire",
    noCommentsYet: "Aucun commentaire pour le moment",
    beFirstToComment: "Soyez le premier à commenter cet épisode !",
    failedToFetchComments: "Échec du chargement des commentaires",
    errorFetchingComments: "Erreur lors du chargement des commentaires",
    commentPostedSuccessfully: "Commentaire publié avec succès !",
    fillAllFields: "Veuillez remplir tous les champs",
    error: "Erreur",
    success: "Succès",
    warning: "Avertissement",
    info: "Information",
    commentSubmissionFailed: "Échec de l'envoi du commentaire",
    commentSubmissionError: "Erreur lors de l'envoi. Veuillez réessayer.",

    // Theme
    switchToLightMode: "Passer au mode clair",
    switchToDarkMode: "Passer au mode sombre",

    // Playlist/Queue
    playAll: "Tout Lire",
    pauseButton: "Pause",

    rewind15s: "Reculer 15 secondes",
    forward15s: "Avancer 15 secondes",
    cancel: "Annuler",

    // Icons
    userIcon: "👤",
    loadingSpinner: "Chargement...",
    commentsCount: "{count}",
    commentAuthor: "Auteur",
    commentTimestamp: "Publié {time}",
    dragHandle: "Glisser pour réorganiser",
    removeFromPlaylistTooltip: "Retirer de la file d'attente",
    playIcon: "▶",
    pauseIcon: "⏸",
    emptyIcon: "🎧",
    playlistIcon: "📋",
    commentsIcon: "💬",
    calendarIcon: "📅",
    clockIcon: "⏱️",
    tagsIcon: "🏷️",
    musicIcon: "🎵",
    searchIcon: "🔍",

    // Share Episode
    shareEpisode: "Partager",
    shareEpisodeAtTime: "Partager au moment actuel",
    shareEpisodeTitle: "Écoutez cet épisode",
    shareEpisodeText: "Écoutez cet épisode de podcast !",

    speedOptions: { "0.5": "0.5x", "0.75": "0.75x", "1": "1x", "1.25": "1.25x", "1.5": "1.5x", "2": "2x" },

    // Tooltips
    nowPlayingAria: "Lecture audio en cours",
    searchDialogTitle: "Rechercher et Filtrer les Podcasts",
    searchDialogSubtitle: "Trouvez vos épisodes favoris",
    closeDialog: "Fermer la boîte de recherche",
    previousTrackTooltip: "Piste précédente",
    nextTrackTooltip: "Piste suivante",
    rewindTooltip: "Reculer 15 secondes",
    forwardTooltip: "Avancer 15 secondes",
    playTooltip: "Lire",
    pauseTooltip: "Pause",
    volumeTooltip: "Contrôle du volume",
    speedTooltip: "Vitesse de lecture",
    progressBarTooltip: "Cliquer pour naviguer",
    expandPlayer: "Agrandir le lecteur",
    minimizePlayer: "Réduire le lecteur",
    closePlayer: "Fermer le lecteur",
    toggleMobileMenu: "Basculer le menu mobile",
    selectPodcastToStart: "Sélectionnez un podcast pour commencer",
    chooseFromListOrPlaylist: "Choisissez dans la liste ou ajoutez à votre file d'attente",

    // Summary Statistics
    stats: {
      title: "Statistiques des archives",
      totalEpisodes: "Total d'épisodes",
      totalDuration: "Durée totale",
      dateRange: "Plage de dates",
      averageEpisode: "Épisode moyen",
      averageSize: "{mb} Mo par épisode",
      durationSublabel: "{hours} heures (~{days} jours de contenu)",
      lastUpdated: "Dernière mise à jour : {date}",
    },

    // Install prompt
    install: {
      title: "Installer l'application",
      androidBody: "Ajoutez-la à votre écran d'accueil pour un accès rapide en plein écran.",
      iosBody: "Touchez l'icône Partager, puis « Sur l'écran d'accueil ».",
      cta: 'Installer',
      dismiss: 'Fermer',
    },

    // Offline downloads
    offline: {
      downloadForOffline: 'Télécharger hors-ligne',
      availableOffline: 'Disponible hors-ligne',
      downloading: 'Téléchargement…',
      queued: 'En attente',
      removeOffline: 'Supprimer le téléchargement',
      cancelDownload: 'Annuler',
      downloadFailed: 'Échec du téléchargement',
      downloads: 'Téléchargements',
      storageUsed: 'Stockage utilisé',
      removeAll: 'Tout supprimer',
      noDownloads: 'Aucun téléchargement',
    },

    // Episode detail page (/episode/:id) + "View details" entry points
    episode: {
      notFound: "Épisode introuvable",
      backHome: "Retour à l'accueil",
      viewDetails: "Voir les détails",
      play: "Écouter",
      pause: "Pause",
      share: "Partager",
    },

    // Toasts (replace the old native-dialog share fallbacks)
    toast: {
      linkCopied: "Lien copié",
      copyFailed: "Copie impossible — {url}",
    },

    // Global download strip + downloads-manager Active block (Task 6)
    downloads: {
      remaining: "{count} restant(s)",
      failed: "{count} échec(s)",
      active: "Téléchargements en cours",
      cancel: "Annuler",
      retry: "Réessayer",
    },

    // Destructive-action confirmations (Task 7)
    confirm: {
      removeAllDownloads: {
        title: "Supprimer tous les téléchargements ?",
        message: "Cela supprime tous les épisodes téléchargés sur cet appareil.",
      },
      clearQueue: {
        title: "Vider la file d'attente ?",
        message: "Cela retire tous les épisodes de votre file d'attente.",
      },
      confirm: "Confirmer",
      cancel: "Annuler",
    },
  },
};

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
];

export const defaultLanguage = 'en';
